<template>
    <nav id="main-nav">
        <div><h1>Crypto - Dashboard</h1></div>
        <div></div>
    </nav>
</template>
<script>
    export default {
    };
</script>
<style scoped>
#main-nav{
    width: 100%;
    background-color: #ddd;
    padding: 20px;
    margin-bottom: 40px;
}
</style>